import { defineComponent, createBlock, openBlock, unref, toValue, normalizeClass } from "vue";
import { ErrorMessage } from "vee-validate";
import { cn } from "../../../../lib/utils.js";
import { useFormField } from "./useFormField.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormMessage",
  props: {
    class: {}
  },
  setup(__props) {
    const props = __props, formField = useFormField();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(ErrorMessage), {
      id: unref(formField).formMessageId,
      class: normalizeClass(unref(cn)("text-destructive-foreground text-sm", props.class)),
      name: toValue(unref(formField).name),
      "data-slot": "form-message",
      as: "p"
    }, null, 8, ["id", "class", "name"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormMessage.js.map
